export default __webpack_public_path__ + "static/media/mobdev.14688d0d.png";